import * as React from "react"
import LatestNews from "@components/LatestNews"
import { graphql, useStaticQuery } from "gatsby"
import { NewsThumbnailItem } from "@components/LatestNews/types"

const StrapiLatestNews = ({
    title,
    overline
}: GatsbyTypes.LatestNewsFragment) => {
    const { allStrapiArticle } = useStaticQuery<GatsbyTypes.LatestArticlesQuery>(
        graphql`
            query LatestArticles {
                allStrapiArticle (
                    skip: 0
                    limit: 3
                    sort: {fields: published_date, order: DESC}
                ) {
                    nodes {
                        slug
                        publishedAt: published_date
                        category {
                            title
                            icon {
                                alternativeText
                                file {
                                    childImageSharp {
                                        gatsbyImageData(
                                            height: 32
                                            layout: CONSTRAINED
                                        )
                                    }
                                }
                            }
                        }
                        thumbnail {
                            title
                            text
                            image {
                                file {
                                    childImageSharp {
                                        gatsbyImageData(
                                            width: 400
                                            height: 350
                                            quality: 80
                                            layout: CONSTRAINED
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    )

    return <LatestNews
        subtitle={overline || ""}
        title={title || ""}
        items={allStrapiArticle?.nodes as NewsThumbnailItem[]}
    />
}

export default StrapiLatestNews
